import {useContext} from "react";

import {useQuery} from "@tanstack/react-query";

import {ResponseError} from "@globals/types/utilityTypes";

import {DishDetailsConfigContext} from "@components/DishDetails";

import {getMenuFetcher} from "../MenuService";
import {Menu, MenuResource, UseMenuParams} from "../interfaces";

export default function useMenu({
  enabled = true,
  menuType,
  ...menuParams
}: UseMenuParams): MenuResource {
  const {menuType: contextMenuType} = useContext(DishDetailsConfigContext);
  const menuFetcher = getMenuFetcher(menuType ?? contextMenuType);

  const cachedQuery = useQuery<Menu, ResponseError>({
    queryKey: ["menu", menuParams, "cached"],
    queryFn: () =>
      menuFetcher({use_cache: true, ignore_inventory: true, ...menuParams}),
    enabled: enabled,
  });

  const {data, isError, isPending, error} = useQuery<Menu, ResponseError>({
    queryKey: ["menu", menuParams],
    queryFn: () => menuFetcher(menuParams),
    placeholderData: cachedQuery?.data,
    enabled: enabled,
  });

  return {
    menu: data,
    isError: isError,
    isLoading: isPending,
    error: error,
  };
}
